
<div class="vincent_404_content_wrapper">
    <div class="vincent_404_content_inner">
        <p class="vincent_404_text">404</p>
    </div>
</div>